import { render, staticRenderFns } from "./DocsStatusRing.vue?vue&type=template&id=1f9e9e50&scoped=true"
import script from "./DocsStatusRing.vue?vue&type=script&lang=js"
export * from "./DocsStatusRing.vue?vue&type=script&lang=js"
import style0 from "./DocsStatusRing.vue?vue&type=style&index=0&id=1f9e9e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e9e50",
  null
  
)

export default component.exports